// extracted by mini-css-extract-plugin
module.exports = {"container":"container--HaqCL","title":"title--EGcsY","game-list":"game-list--HXZHk","game-item":"game-item--r50nc","game-logo":"game-logo--bl2jQ","game-title":"game-title--4UAbY"};